const style = (theme: any) => {
  return {
    headerWrapper: {
      background: "#F9F9FF",
      boxShadow: "0px 2px 14px rgba(39, 55, 84, 0.08)",
      width: "fit-content",
      minWidth: "100%",
      height: "auto",
      position: "relative" as const,
      top: 0,
      zIndex: 3,
    },

    notVerifiedWrapper: {
      height: "auto",
    },

    eddmHeaderWrapper: {
      background: "#FFFFFF",
      boxShadow: "none",
    },

    container: {
      width: "100%",
      height: "80px",
      display: "flex",
      justifyContent: "flex-start",
      [theme.breakpoints.down(768)]: {
        height: "100%",
      },
    },

    flyerContainer: {
      width: "100%",
      height: "80px",
      display: "flex",
      alignItems: "center",
      paddingTop: 10,
      paddingBottom: 10,
    },

    nameAndBadgeWrapper: {
      display: "flex",
      alignItems: "center",

      "& > p": {
        color: "#011533",
        fontWeight: 700,
        fontSize: "20px",
        lineHeight: "26px",
      },
    },

    homeAndBackWrapper: {
      display: "flex",
      alignItems: "center",
      marginLeft: "56px",
    },

    firstHeaderItem: {
      flex: 1,
      maxWidth: "33%",
      [theme.breakpoints.down(1520)]: {
        maxWidth: "25%",
      },
      [theme.breakpoints.down(1200)]: {
        maxWidth: "15%",
      },
    },

    middleHeaderItem: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: "33%",
      [theme.breakpoints.down(1520)]: {
        maxWidth: "25%",
      },
      [theme.breakpoints.down(1200)]: {
        maxWidth: "35%",
      },
    },

    lastHeaderItem: {
      flex: 1,
      maxWidth: "33%",
      [theme.breakpoints.down(1520)]: {
        maxWidth: "50%",
      },
    },
    newNavigationBtnsWrapper: {
      width: "calc(100% - 96px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginRight: 0,
      [theme.breakpoints.down(768)]: {
        width: "100%",
        height: "48px",
        padding: "0 16px",

        "& > *": {
          flex: "1 1 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },

        "& > *:first-child": {
          justifyContent: "flex-start",
        },

        "& > *:last-child": {
          justifyContent: "flex-end",
        },

        "& .MuiTypography-root": {
          fontWeight: 600,
          fontSize: "14px !important",
          lineHeight: "20px",
        },
      },
    },

    newNavigationBtnsWrapperEDDMOnly: {
      width: "calc(100% - 132px)",
    },

    gridWrapper: {
      position: "relative" as const,
      display: "flex",
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      margin: "0 20px",
      [theme.breakpoints.down(768)]: {
        margin: "0 0",
        width: "100%",
        flexDirection: "column",
      },
    },

    backBtn: {
      cursor: "pointer",
      display: "flex",
      transition: ".3s all",
      width: "fit-content",
      [theme.breakpoints.down(768)]: {
        width: "auto",
      },

      "& > img": {
        marginRight: "18px",
        marginBottom: "auto",
        [theme.breakpoints.down(768)]: {
          marginRight: "6px",
        },
      },
      "& > p": {
        color: "#011533",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "20px",
      },
    },

    homeBtn: {
      marginRight: "40px",
    },

    tabsWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    tabWrapper: {
      display: "flex",
      alignItems: "center",
      marginLeft: "6px",
    },

    tab: {
      cursor: "default",
      color: "rgba(0, 0, 0, 0.26)",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
    },

    activeTab: {
      color: "#000000",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "20px",
    },

    link: {
      cursor: "pointer",
    },

    alertLink: {
      color: "#0C172C",
      marginLeft: 20,
      textDecoration: "underline",
      fontSize: 16,
    },

    separator: {
      background: "black",
      height: "2px",
      width: "30px",
      margin: "0 12px",
    },

    disabled: {
      background: "rgba(0, 0, 0, 0.26)",
    },

    flyerBuilderNavigationBtnsWrapper: {
      width: "100%",
      display: "flex",
      "& > img, & > div": {
        cursor: "pointer",
        marginLeft: "18px",
      },

      "& > div": {
        display: "flex",
        alignItems: "center",
        "& > span": {
          marginLeft: "10px",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
    },

    navigationHelp: {
      width: "80px",
      [theme.breakpoints.down(768)]: {
        width: "auto",
      },
    },

    newNavigationLogoWrapper: {
      width: "80px",
      display: "flex",
      alignItems: "center",
      marginRight: 0,
      [theme.breakpoints.down(768)]: {
        width: "100%",
        height: "48px",
        borderBottom: "1px solid #E2E2FC",
      },
    },

    stepsContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      [theme.breakpoints.down(768)]: {
        width: "100%",
      },
    },

    homeBtnContainer: {
      marginRight: "16px",

      "@media (max-width: 768px)": {
        marginRight: 0,
        marginLeft: "12px",
      },
    },

    navigationBtn: {
      cursor: "pointer",
      border: "1px solid #273754",
      borderRadius: "16px",
      padding: "14px 52px",
      color: "#00112B",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "20px",
      transition: ".3s all",
      margin: "0 6px",
      alignItems: "center",
      display: "flex",
      position: "relative" as const,

      "&:hover": {
        transform: "scale(1.02)",
      },
    },

    navigationActive: {
      background: "#EE4360",
      border: "none",
      paddingRight: "65px",
      color: "#FFFFFF",
    },

    navigationDisabled: {
      background: "#C2C8D1",
      border: "none",
      paddingRight: "60px",
      color: "#FFFFFF",
    },

    marginRight20: {
      marginRight: "20px",
    },
    item: {
      padding: "10px",
      borderRadius: "8px",
      display: "flex",
      color: "rgb(46, 56, 96);",
      height: "100%",
      alignItems: "center",
    },
    displayNone: {
      display: "none",
    },
    itemCanBeActive: {
      cursor: "pointer",
      "&:hover": {
        background: "#E2E2FC",
      },
    },

    dotsContainer: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      gap: "7px",
    },
    dot: {
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: "#d3d3d3",
    },
    activeDot: {
      backgroundColor: "#000",
      width: 6,
      height: 6,
    },
    mobTabWrapper: {
      position: "relative" as const,
      display: "flex !important",
      flexDirection: "column" as const,
      height: "90%",
      alignItems: "center",
      justifyContent: "space-around",
    },
  };
};

export default style;
